import { render, staticRenderFns } from "./sign-page.vue?vue&type=template&id=2fa604ee&scoped=true&"
import script from "./sign-page.vue?vue&type=script&lang=ts&"
export * from "./sign-page.vue?vue&type=script&lang=ts&"
import style0 from "./sign-page.vue?vue&type=style&index=0&id=2fa604ee&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa604ee",
  null
  
)

export default component.exports